import { createSlice } from "@reduxjs/toolkit";
import Types from "../../../constants/types";

const initialState = {
  accountVerificationData: null,
  aoNewRequestData: null,
  isExistingUser: null,
  isExistingCardCustomer: null,
  existingUser: null,
  cifNo: null,
  requestId: null,
  customerId: null,
  personId: Types.PERSON_ID_PRIMARY_CUSTOMER,
  personTypeId: Types.PRIMARY_CUSTOMER,
  noOfOtpAttempt: 0,
};

const loginReducer = createSlice({
  name: "LoginReducer",
  initialState: initialState,
  reducers: {
    setAccountVerificationData: (state, { payload }) => {
      state.accountVerificationData = payload;
    },
    setAoNewRequestData: (state, { payload }) => {
      state.aoNewRequestData = payload;
    },
    setIsExistingUser: (state, { payload }) => {
      state.isExistingUser = payload;
    },
    setIsExistingCardCustomer: (state, { payload }) => {
      state.isExistingCardCustomer = payload;
    },
    setExistingUser: (state, { payload }) => {
      state.existingUser = payload;
    },
    setCIFNo: (state, { payload }) => {
      state.cifNo = payload;
    },
    setRequestId: (state, { payload }) => {
      state.requestId = payload;
    },
    setCustomerId: (state, { payload }) => {
      state.customerId = payload;
    },
    setPersonId: (state, { payload }) => {
      state.personId = payload;
    },
    setPersonTypeId: (state, { payload }) => {
      state.personTypeId = payload;
    },
    setNoOfOtpAttempt: (state, { payload }) => {
      state.noOfOtpAttempt = payload;
    },
  },
});

export default loginReducer;
